@media screen and (max-width: 860px) {
  .app-pricing-rows {
    flex-direction: column;
  }
  .app-pricing-row {
    flex: inherit;
  }
}
